import { mapRange } from '@wix/wow-utils';
import { getCssUnits, getMouseTransitionEasings, } from '../../../utils/animationsUtils';
export const name = 'Track3DMouse';
export const properties = {
    schema: {},
};
export function animate(_kit, elements, _duration, _delay, { inverted = false, distance = { value: 200, type: 'px' }, angle = 5, axis = 'both', perspective = 800, currentRotation = 0, transitionDuration, transitionEasing = 'linear', } = {}) {
    const element = elements[0];
    const invert = inverted ? -1 : 1;
    if (transitionDuration) {
        element.style.transition = `transform ${transitionDuration}ms ${getMouseTransitionEasings(transitionEasing)}`;
    }
    return {
        progress(progressX, progressY) {
            let translateX = 0;
            let translateY = 0;
            let rotateX = 0;
            let rotateY = 0;
            // if progressX === 0, translateX === -distance
            // if progressX === 0.5, translateX === 0
            // if progressX === 1, translateX === distance
            // if progressX === 0, rotateX === -angle, if progressX === 0.5, rotateX === 0, if progressX === 1, rotateX === angle
            if (axis === 'both' || axis === 'horizontal') {
                translateX = mapRange(0, 1, -distance.value, distance.value, progressX);
                rotateY = mapRange(0, 1, -angle, angle, progressX) * invert;
            }
            if (axis === 'both' || axis === 'vertical') {
                translateY = mapRange(0, 1, -distance.value, distance.value, progressY);
                rotateX = mapRange(0, 1, angle, -angle, progressY) * invert;
            }
            const units = getCssUnits(distance.type);
            element.style.transform = `perspective(${perspective}px) translateX(${translateX}${units}) translateY(${translateY}${units}) rotateX(${rotateX}deg) rotateY(${rotateY}deg) rotate(${currentRotation}deg)`;
        },
        kill() {
            element.style.transform = '';
            element.style.transition = '';
        },
    };
}
//# sourceMappingURL=track3DMouse.js.map